import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import { callerWithDobParts } from '@/Utils/callerWithDobParts';
import { planCurrency, planPricing } from '@/services/pricing';
import type { Caller, CallerQueryInput } from '@/models/caller';

// Fragments
import './fragments/callerFragment';

export const fetchCustomerInfo = async ({ phoneNumber, partnerId }: CallerQueryInput) => {
  const response = await queryExecute({
    variables: {
      phoneNumber,
      partnerId,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query Caller($phoneNumber: String, $partnerId: Float) {
        caller(phoneNumber: $phoneNumber, partnerId: $partnerId) {
          ...CallerFragment
        }
      }
    `),
  });

  const caller = callerWithDobParts(response.data.caller as Caller);

  if (caller?.planPricing) {
    planPricing.value = caller.planPricing;
    planCurrency.value = (caller.currency as 'USD') ?? 'USD';
  }

  return caller;
};
